/* eslint-disable no-redeclare */
import { A365BackendModel as Model } from '../a365.backendmodel';
import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { ScriptMetadata, SqlScript, SqlScriptContent, SqlScriptConnectionKey, SqlScriptConnectionKeyV3 } from '../sqlscript/sqlscript';
import { NamedAdapter } from './named.adapter';
import { ModelConstants } from '../model-constants';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlScript),
    adapts: {
        name: '*',
        properties: {
            description: '*',
            content: '*',
            folder: '*'
        }
    }
})
export class SqlScriptAdapter extends NamedAdapter<SqlScript, Model.SqlScriptResource> {
    protected _toResource(sqlscript: SqlScript): Model.SqlScriptResource {
        const sqlScriptResource = super._toResource(sqlscript) as Model.SqlScriptResource;
        this.properties(sqlScriptResource).content = {};
        sqlScriptResource.properties.type = sqlscript.type;

        if (sqlscript.content) {
            sqlScriptResource.properties.content.query = sqlscript.content.query;
            if (sqlscript.content.metadata) {
                sqlScriptResource.properties.content.metadata = {
                    language: sqlscript.content.metadata.language
                };
            }

            if (sqlscript.content.currentConnection) {
                if (isV3ConnectionKey(sqlscript.content.currentConnection)) {
                    sqlScriptResource.properties.content.currentConnection = {
                        databaseName: sqlscript.content.currentConnection.databaseName,
                        poolName: sqlscript.content.currentConnection.poolName,
                        poolType: sqlscript.content.currentConnection.poolType
                    };
                } else {
                    sqlScriptResource.properties.content.currentConnection = {
                        name: sqlscript.content.currentConnection.name,
                        type: sqlscript.content.currentConnection.type
                    };
                }
            }
            sqlScriptResource.properties.content.resultLimit = sqlscript.content.resultLimit;
        }

        return sqlScriptResource;
    }

    protected _toModel(sqlScriptResource: Model.SqlScriptResource, sqlscript?: SqlScript): SqlScript {
        if (!sqlscript) {
            sqlscript = SqlScript.MODEL.create<SqlScript>();
        }
        super._toModel(sqlScriptResource, sqlscript);
        sqlscript.resourceType = ModelConstants.sqlScript + 's';

        if (sqlScriptResource.properties) {
            sqlscript.type = sqlScriptResource.properties.type;

            if (sqlScriptResource.properties.content) {
                if (!sqlscript.content) {
                    sqlscript.content = new SqlScriptContent();
                }

                sqlscript.content.query = sqlScriptResource.properties.content.query;

                if (sqlScriptResource.properties.content.metadata) {
                    if (!sqlscript.content.metadata) {
                        sqlscript.content.metadata = new ScriptMetadata();
                    }
                    sqlscript.content.metadata.language = sqlScriptResource.properties.content.metadata.language;
                }

                if (sqlScriptResource.properties.content.currentConnection) {
                    if (isV3ConnectionKey(sqlScriptResource.properties.content.currentConnection)) {
                        sqlscript.content.currentConnection = new SqlScriptConnectionKeyV3();
                        sqlscript.content.currentConnection.databaseName = sqlScriptResource.properties.content.currentConnection.databaseName;
                        sqlscript.content.currentConnection.poolName = sqlScriptResource.properties.content.currentConnection.poolName;
                        sqlscript.content.currentConnection.poolType = sqlScriptResource.properties.content.currentConnection.poolType;
                    } else {
                        sqlscript.content.currentConnection = new SqlScriptConnectionKey();
                        sqlscript.content.currentConnection.name = sqlScriptResource.properties.content.currentConnection.name;
                        sqlscript.content.currentConnection.type = sqlScriptResource.properties.content.currentConnection.type;
                    }
                }

                sqlscript.content.resultLimit = sqlScriptResource.properties.content.resultLimit;
            }
        }

        return sqlscript;
    }
}

function isV3ConnectionKey(connectionKey: Model.ScriptConnectionKey | Model.ScriptConnectionKeyV3): connectionKey is Model.ScriptConnectionKeyV3;
function isV3ConnectionKey(connectionKey: SqlScriptConnectionKey | SqlScriptConnectionKeyV3): connectionKey is SqlScriptConnectionKeyV3;
function isV3ConnectionKey(connectionKey: SqlScriptConnectionKey | SqlScriptConnectionKeyV3 | Model.ScriptConnectionKey | Model.ScriptConnectionKeyV3): boolean {
    return 'poolName' in connectionKey || 'databaseName' in connectionKey || 'poolType' in connectionKey;
}
